/*
 * Actions describe changes of state in your application
 */

// We import constants to name our actions' type
import {
  CHANGE_FORM,
  SET_AUTH,
  SENDING_REQUEST,
  LOGIN_REQUEST,
  CHANGE_FORM_REGISTER,
  REGISTER_REQUEST,
  LOGOUT,
  REQUEST_ERROR,
  CLEAR_ERROR,
  FORGOT_PASSWORD,
  CHANGE_FORM_FORGOT,
  CHANGE_FORM_BUSINESS,
  BUSINESS_TYPES_REQUEST,
  SHOW_PROGRESS_BAR,
  HIDE_PROGRESS_BAR,
  SET_AUTH_FROM_LOCAL,
  SET_AUTH_FROM_API,
  RESEND_VERIFICATION_EMAIL,
  GET_FILTERED_DATE,
  REGISTER_BUSINESS_REQUEST,
  CHANGE_BUSINESS_TYPES_DATA,
  BUSINESS_CATEGORIES_REQUEST,
  CHANGE_BUSINESS_CATEGORIES_DATA,
  REDIRECT_TO,
  LOAD_RESET_PASSWORD,
  CHANGE_FORM_RESET_PASSWORD,
  SEND_RESET_PASSWORD,
  LOAD_PREPARE_ENCRYPTION,
  SET_PREPARE_ENCRYPTION,
  GET_PROFILE_REQUEST,
  SET_PROFILE,
  CLEAR_REGISTER_FORM,
  SHOW_LOADING_SPINNER,
  SET_IS_REGISTERED,
  SET_RESEND_VERIFICATION_EMAIL_STATE,
  TO_LOGIN_PAGE,
  TO_SIGNUP_PAGE,
  DASHBOARD_SHOW_MODAL_OUTLET_MOBILE
} from './constants'

/**
 * Show the progress bar
 * @returns {{type, payload: {}}}
 */
export function showProgressBar () {
  return {type: SHOW_PROGRESS_BAR}
}
export function showLoadingSpinner (showLoadingSpinner) {
  return {type: SHOW_LOADING_SPINNER, payload: {showLoadingSpinner}}
}

export function hideProgressBar () {
  return {type: HIDE_PROGRESS_BAR}
}

/**
 * Sets the form state
 * @param  {object} newFormState          The new state of the form
 * @param  {string} newFormState.email   The new text of the email input field of the form
 * @param  {string} newFormState.password The new text of the password input field of the form
 */
export function changeForm (newFormState) {
  return {type: CHANGE_FORM, payload: {newFormState}}
}
export function showModalOutletMobile (value) {
  return {type: DASHBOARD_SHOW_MODAL_OUTLET_MOBILE, payload: {showModalOutletMobile: value}}
}
/**
 * Sets the form state
 * @param  {object} newFormRegState          The new state of the form
 * @param  {string} newFormRegState.email The new text of the email input field of the form
 * @param  {string} newFormRegState.password The new text of the password input field of the form
 * @param  {string} newFormRegState.confpassword The new text of the confirm password input field of the form
 */
export function changeFormRegister (newFormRegState) {
  return {type: CHANGE_FORM_REGISTER, payload: {newFormRegState}}
}

/**
 * Sets the form forgot state
 * @param  {object} newForgotState          The new state of the form
 * @param  {string} newForgotState.email The new text of the email input field of the form
 */
export function changeFormForgot (newForgotState) {
  return {type: CHANGE_FORM_FORGOT, payload: {newForgotState}}
}

/**
 * Sets the form forgot state
 * @param  {object} newBusinessState          The new state of the form
 * @param  {string} newBusinessState.types The new text of the email input field of the form
 */
export function changeFormBusiness (newBusinessState) {
  return {type: CHANGE_FORM_BUSINESS, payload: {newBusinessState}}
}

/**
 * Sets the authentication state of the application
 * @param  {boolean} newAuthState True means a user is logged in, false means no user is logged in
 * @param  {object} user object. null if auth fails.
 */
export function setAuthState (newAuthState, user) {
  return {type: SET_AUTH, payload: {newAuthState, user}}
}

/**
 * Sets the `currentlySending` state, which displays a loading indicator during requests
 * @param  {boolean} sending True means we're sending a request, false means we're not
 */
export function sendingRequest (sending) {
  return {type: SENDING_REQUEST, payload: {sending}}
}

/**
 * Tells the app we want to log in a user
 * @param  {object} data          The data we're sending for log in
 * @param next
 * @param  {string} data.email The username of the user to log in
 * @param  {string} data.password The password of the user to log in
 */
export function loginRequest (data, next = null) {
  return {type: LOGIN_REQUEST, payload: {data, next}}
}

/**
 * Tells the app we want to log out a user
 */
export function logout () {
  return {type: LOGOUT}
}

export function resendVerificationEmail (email) {
  return {type: RESEND_VERIFICATION_EMAIL, payload: {email}}
}

/**
 * Tells the app we want to register a user
 * @param  {object} data          The data we're sending for registration
 * @param  {string} data.username The username of the user to register
 * @param  {string} data.password The password of the user to register
 * @param  {string} data.confpassword The confirm password of the user to register
 */
export function registerRequest (data) {
  return {type: REGISTER_REQUEST, payload: {data}}
}

/**
 * Sets the `error` state to the error received
 * @param  {object} error The error we got when trying to make the request
 */
export function requestError (error) {
  return {type: REQUEST_ERROR, payload: {error}}
}

export function forgotPassword (data) {
  return {type: FORGOT_PASSWORD, payload: {data}}
}

export function businessTypes () {
  return {type: BUSINESS_TYPES_REQUEST}
}

export function changeBusinessTypesData (newBusinessTypes) {
  return {type: CHANGE_BUSINESS_TYPES_DATA, payload: {newBusinessTypes}}
}

export function businessCategories (data) {
  return {type: BUSINESS_CATEGORIES_REQUEST, payload: {data}}
}

export function changeBusinessCategoriesData (newBusinessCategories) {
  return {type: CHANGE_BUSINESS_CATEGORIES_DATA, payload: {newBusinessCategories}}
}

export function registerBusinessRequest (data) {
  return {type: REGISTER_BUSINESS_REQUEST, payload: {data}}
}

/**
 * Sets the `error` state as empty
 */
export function clearError () {
  return {type: CLEAR_ERROR}
}

export function setAuthFromLocal () {
  return {type: SET_AUTH_FROM_LOCAL}
}

export function setAuthFromApi (data) {
  return {type: SET_AUTH_FROM_API, payload: {data}}
}

export function getFilteredDate (data) {
  return {type: GET_FILTERED_DATE, payload: {filteredDate: data}}
}

export function redirectTo (data) {
  return {type: REDIRECT_TO, payload: {url: data}}
}

export function loadResetPassword (data) {
  return {type: LOAD_RESET_PASSWORD, payload: {token: data}}
}

export function changeFormResetPassword (data) {
  return {type: CHANGE_FORM_RESET_PASSWORD, payload: {resetPasswordState: data}}
}

export function resetPassword (data, token, key) {
  return {type: SEND_RESET_PASSWORD, payload: {data, access_token: token}}
}

export function loadPrepareEncryption () {
  return {type: LOAD_PREPARE_ENCRYPTION}
}

export function setPrepareEncryption (data) {
  return {type: SET_PREPARE_ENCRYPTION, payload: {encryption: {public_modulus: data.responseData.public_modulus, public_exponent: data.responseData.public_exponent, key: data.responseData.public_exponent}}}
}

export function getProfileRequest (query) {
  return {type: GET_PROFILE_REQUEST, payload: {query}}
}

export function setProfile (profile) {
  return {type: SET_PROFILE, payload: {profile}}
}

export function clearRegisterForm () {
  return {type: CLEAR_REGISTER_FORM}
}

export function setIsRegistered (isRegistered) {
  return {type: SET_IS_REGISTERED, payload: {isRegistered}}
}

export function setResendEmailVerificationState (data) {
  return {type: SET_RESEND_VERIFICATION_EMAIL_STATE, payload: {resendVerificationEmail: {isModalShow: data.isModalShow, headerMessage: data.headerMessage, bodyMessage: data.bodyMessage, modalStatus: data.modalStatus}}}
}

export function toLoginPage () {
  return {type: TO_LOGIN_PAGE}
}

export function toSignUpPage () {
  return {type: TO_SIGNUP_PAGE}
}



// WEBPACK FOOTER //
// ./app/actions/index.js